





















































































import Vue, { PropType } from "vue";

import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider
} from "vee-validate";
import { length, required } from "vee-validate/dist/rules";
import Ice from "@/lib/ice";

let ACTIVATION_CODE_MIN_LENGTH: number; // PHP側から定数をpropsで取得したものを受け取るための値
let ACTIVATION_CODE_MAX_LENGTH: number; // PHP側から定数をpropsで取得したものを受け取るための値

extend("required", required);
extend("length", length);
extend("ignoreHyphenLength", value => {
  const activationCodeIgnoreHyphenLength = value.replace(/-/g, "").length;
  return (
    activationCodeIgnoreHyphenLength >= ACTIVATION_CODE_MIN_LENGTH &&
    activationCodeIgnoreHyphenLength <= ACTIVATION_CODE_MAX_LENGTH
  );
});

export interface InputActivationCodeProps {
  locale: string;
  lang: any;
  validationLang: any;
  csrfToken: string;
  actionUrl: string;
  initialActivationCode: string;
  initialErrors: string[];
  isLoggedIn: boolean;
  validationActivationCodeMinLength: number;
  validationActivationCodeMaxLength: number;
  alreadyConsumedCaption: string;
  alreadyConsumedCaptionLink: string;
  alreadyConsumedCaptionLinkText: string;
}

export interface InputActivationCodeData {
  code: string;
  placeholder: string;
}

export default Vue.extend({
  name: "vc-activation-code-input-activation-code",
  computed: {
    Ice() {
      return Ice;
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    locale: {
      type: String as PropType<InputActivationCodeProps["locale"]>,
      default: ""
    },
    lang: {
      type: Object as PropType<InputActivationCodeProps["lang"]>,
      default: ""
    },
    validationLang: {
      type: Object as PropType<InputActivationCodeProps["lang"]>,
      default: ""
    },
    csrfToken: {
      type: String as PropType<InputActivationCodeProps["csrfToken"]>,
      default: ""
    },
    actionUrl: {
      type: String as PropType<InputActivationCodeProps["actionUrl"]>,
      default: ""
    },
    initialActivationCode: {
      type: String as PropType<
        InputActivationCodeProps["initialActivationCode"]
      >,
      default: ""
    },
    initialErrors: {
      type: Array as PropType<InputActivationCodeProps["initialErrors"]>,
      default: []
    },
    isLoggedIn: {
      type: Boolean as PropType<InputActivationCodeProps["isLoggedIn"]>,
      default: false
    },
    validationActivationCodeMinLength: {
      type: Number as PropType<
        InputActivationCodeProps["validationActivationCodeMinLength"]
      >,
      default: 12
    },
    validationActivationCodeMaxLength: {
      type: Number as PropType<
        InputActivationCodeProps["validationActivationCodeMaxLength"]
      >,
      default: 13
    },
    alreadyConsumedCaption: {
      type: String as PropType<
        InputActivationCodeProps["alreadyConsumedCaption"]
      >,
      default: ""
    },
    alreadyConsumedCaptionLink: {
      type: String as PropType<
        InputActivationCodeProps["alreadyConsumedCaptionLink"]
      >,
      default: ""
    },
    alreadyConsumedCaptionLinkText: {
      type: String as PropType<
        InputActivationCodeProps["alreadyConsumedCaptionLinkText"]
      >,
      default: ""
    }
  },
  data(): InputActivationCodeData {
    return {
      code: "",
      placeholder: this.isLoggedIn ? "" : this.lang.please_login
    };
  },
  mounted() {
    this.code = this.initialActivationCode;
    ACTIVATION_CODE_MIN_LENGTH = this.validationActivationCodeMinLength;
    ACTIVATION_CODE_MAX_LENGTH = this.validationActivationCodeMaxLength;
    localize(this.locale, {
      messages: {},
      fields: {
        code: {
          required: this.validationLang.required,
          ignoreHyphenLength: this.validationLang.length
            .replace(":min_length", ACTIVATION_CODE_MIN_LENGTH.toString())
            .replace(":max_length", ACTIVATION_CODE_MAX_LENGTH.toString())
        }
      }
    });
  },
  methods: {
    onSubmit() {
      (this.$refs.form as HTMLFormElement).submit();
    }
  }
});
